import React, { ReactElement } from 'react';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import { WorkLanguageDTO } from 'api/core/models';
import { IntlShape, useIntl } from 'react-intl';
import { getDefaultWorkLanguage } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { getVocabularyOptions } from '../../../../Vocabulary/util';
import { Panel } from '../layout/Panel';
import { InputGroup } from '../layout/InputGroup';

interface WorkLanguagesProps {
  workLanguages?: WorkLanguageDTO[];
  onChange: (data: WorkLanguageDTO[]) => void;
  listPartition: string;
  checkPermission: CheckPermissionFunction;
  validation: ValidationResult;
  autoFocus: boolean;
}

export function WorkLanguages(props: WorkLanguagesProps): ReactElement {
  const intl: IntlShape = useIntl();

  return (
    <Panel title={`work.attr.languages`}>
      <MultiInputControls<WorkLanguageDTO>
        canEdit={props.checkPermission().canWrite}
        lines={props.workLanguages}
        onChange={(lines: WorkLanguageDTO[]): void => props.onChange(lines)}
        addNew={(rows: WorkLanguageDTO[]): number => rows.push(getDefaultWorkLanguage())}
        renderLines={(wl: WorkLanguageDTO, onLineChange: (workLanguageDTO: WorkLanguageDTO) => void, actions: Actions, idx: number): ReactElement => (
          <InputGroup delete={{
            action: actions.delete,
            disabled: !props.checkPermission().canWrite,
          }}>
            <LabelledDropdown
              onChange={(language: string): void => onLineChange({language})}
              autoFocus={props.autoFocus}
              id={'language'}
              filter={true}
              value={wl.language ? wl.language : ''}
              permissions={props.checkPermission()}
              validation={props.validation?.children[idx]?.fields?.language}
              options={getVocabularyOptions(intl.locale, 'language_list', props.listPartition)}
              label={`work.attr.language`}
            />
          </InputGroup>
        )}
      />
    </Panel>
  );
}
